export const getCategory = () => {
    const cards = [
      {
        id: 0,
        imageSrc:
          require("../images/images/depositphotos_64087125-stock-photo-raw-cereals.jpg"),
        title: "Flakes, Cereals, Grains and Legumes",
        queryBy: 'Flakes_Cereal_Grains_and_Legumes',
        content: "RICE, WHEAT, BEANS, SOY, ETC.",
        price: "400",
        rating: "5.0",
        reviews: "87",
        url: "#"
      },
      {
        id: 1,
        imageSrc:
        require("../images/images/di9h5x7chs1.jpg"),
        title: "Tubers",
        queryBy: 'Tubers',
        content: "YAM, CASSAVA, POTATOES, WATER YAM, ETC.",
        price: "300",
        rating: "4.5",
        reviews: "34",
        url: "#"
      },
      {
        id: 2,
        imageSrc:
        require("../images/images/fresh-sweet-apricots-on-white-table-with-whole-cantaloupe-4397916.jpg"),
        title: "Pepper, Vegetables and Fruits",
        queryBy: 'Pepper_Vegetables_and_Fruits',
        content: "SPINACH, APPLE, PINEAPPLE, BANANA, ORANGES, ETC.",
        price: "50",
        rating: "3.9",
        reviews: "26",
        url: "#"
      },
      {
        id: 3,
        imageSrc:
        require("../images/images/how-to-properly-store-spices.jpg"),
        title: "Spices",
        queryBy: 'Spices',
        content: "SALT, MAGGI, CURRY, THYME, GINGER, ETC.",
        price: "20",
        rating: "4.2",
        reviews: "95",
        url: "#"
      },
      {
        id: 4,
        imageSrc:
        require("../images/images/Tomato-prices-are-up-by-over-80-in-these-Lagos-810x507.jpg"),
        title: "Pepper",
        category: 'Pepper',
        queryBy: "TOMATOES, RODO(SCOTCH-BOONET), TATASHE(BELL PEPPER), ETC.",
        price: "100",
        rating: "5.0",
        reviews: "61",
        url: "#"
      },
      {
        id: 5,
        imageSrc:
        require("../images/images/2017.png"),
        title: "Sea and Frozen Foods",
        queryBy: 'Sea_and_Frozen_Foods',
        content: "FISH, MEAT, ETC.",
        price: "$100",
        rating: "4.9",
        reviews: "89",
        url: "#"
      },
      {
        id: 6,
        imageSrc:
        require("../images/images/pngwing.com.png"),
        title: "Cakes and Pastries",
        queryBy: 'Cakes_and_Pastries',
        content: "BREAD, PIE, SAUSAGE ROLL, DOUGHNUT, ETC",
        price: "100",
        rating: "4.6",
        reviews: "12",
        url: "#"
      },
      {
        id: 7,
        imageSrc:
        require("../images/images/45-250x250.jpg"),
        title: "Miscs",
        queryBy: 'Miscs',
        content: "GROUNDNUT, HONEY, KULI, SUGAR, ETC",
        price: "100",
        rating: "4.2",
        reviews: "19",
        url: "#"
      }
    ];
  
    // Shuffle array
    return cards.sort(() => Math.random() - 0.5);
};

export const getMarket = () => {
    const cards = [
      {
        id: 0,
        imageSrc:
          require("../images/images/Food_Seafood_Frozen.jpg"),
        title: "Adept Sea Foods",
        queryBy: "Adept_Sea_Foods",
        content: "fish, meat, etc",
        contentArray: ["Fish", "Meat"],        
        price: "100",
        rating: "5.0",
        reviews: "87",
        url: "#"
      },
      {
        id: 1,
        imageSrc:
        require("../images/images/di9h5x7chs1.jpg"),
        title: "Mama Bola Tuber Stores",
        queryBy: "Mama_Bola_Tuber_Stores",
        content: "yam, potatoes, cocoayam, ETC.",
        contentArray: ['Yam', 'Potatoes', 'Cocoyam'],
        price: "300",
        rating: "4.5",
        reviews: "34",
        url: "#"
      },
      {
        id: 2,
        imageSrc:
        require("../images/images/Dried_and_smoked_fish_export_5.jpg"),
        title: "AB Seafood Ventures",
        queryBy: "AB_Seafood_Ventures",
        content: "Smoked Fish, Dried Fish, Fresh Fish.",
        contentArray: ['Smoked Fish', 'Dried Fish', 'Fresh Fish'],
        price: "100",
        rating: "3.9",
        reviews: "26",
        url: "#"
      },
      {
        id: 3,
        imageSrc:
        require("../images/images/people-around-a-table-with-food-4262172.jpg"),
        title: "Seyi Spices",
        queryBy: "Seyi_Spices",
        content: "Salt, groundnut oil, maggi, etc.",
        contentArray: ['Salt', 'Groundnut oil', 'Maggi'],
        price: "100",
        rating: "4.2",
        reviews: "95",
        url: "#"
      },
      {
        id: 4,
        imageSrc:
        require("../images/images/tomato-erily-mariel-unsplash.jpg"),
        title: "Fine Five Pepper",
        queryBy: "Fine_Five_Pepper",
        content: "TOMATOES, RODO, TATASHE, BAWA, ETC.",
        contentArray: ['Tomatoes', 'Rodo(Scotch Boonet', 'Tatashe(Bell Pepper)', 'Bawa'],
        price: "100",
        rating: "5.0",
        reviews: "61",
        url: "#"
      },
      {
        id: 5,
        imageSrc:
        require("../images/images/african-american-5041078_1280.jpg"),
        title: "Susan Pastries",
        queryBy: "Susan_Pastries",
        content: "Bread, Sausage, Scotch egg.",
        contentArray: ['Bread', 'Sausage', 'Scotch Egg'],
        price: "100",
        rating: "4.9",
        reviews: "89",
        url: "#"
      },
      {
        id: 6,
        imageSrc:
        require("../images/images/e64c8b5fab4b436f8297e4b8962f1900.jpg"),
        title: "Sweit Cakes and Pastries",
        queryBy: "Sweit_Cakes_and_Pastries",
        content: "Snacks, bread, Doughnuts, Sausage Rolls, ETC",
        contentArray: ['Snacks', 'Bread', 'Doughnuts', 'Sausage Rolls'],
        price: "100",
        rating: "4.6",
        reviews: "12",
        url: "#"
      },
      {
        id: 7,
        imageSrc:
        require("../images/images/stock-photo-long-rice-in-a-sack-and-wooden-scoop-isolated-on-white-background-389707480.jpg"),
        title: "Laide Grain Stores",
        queryBy: "Laide_Grain_Stores",
        content: "Rice, Beans, Garri, ETC",
        contentArray: ['Rice', 'Beans', 'Garri'],
        price: "400",
        rating: "4.2",
        reviews: "19",
        url: "#"
      }
    ];
  
    // Shuffle array
    return cards.sort(() => Math.random() - 0.5);
}; 

export const getPlaceholderPost = () => ({
  id: 0,
  imageSrc:
    "https://images.unsplash.com/photo-1418854982207-12f710b74003?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1024&q=80",
  category: "Travel Guide",
  date: "April 19, 2020",
  title: "Visit the beautiful Alps in Switzerland",
  description:
    "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.  Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.",
  url: "https://reddit.com",
  featured: true
});
